/**
 * Pluralize a word based on the count
 *
 * @example
 * pluralize({count: 1, singular: 'update', plural: 'updates'})
 * // => "update"
 * pluralize({count: 2, singular: 'update', plural: 'updates'})
 * // => "updates"
 *
 * @param {object} opts
 * @param {number} opts.count - The numeric quantity
 * @param {string} opts.singular - Word form used when count === 1
 * @param {string} opts.plural - Word form used when count !== 1
 * @returns {string}
 * @throws {TypeError} If count is not a valid number or forms are not strings
 */
const pluralize = ({ count, singular, plural } = {}) => {
  if (typeof count !== 'number' || Number.isNaN(count)) {
    throw new TypeError('Count must be a number');
  }

  if (!singular || typeof singular !== 'string') {
    throw new TypeError('Singular must be a string');
  }

  if (!plural || typeof plural !== 'string') {
    throw new TypeError('Plural must be a string');
  }

  return count === 1 ? singular : plural;
};

export default pluralize;
